module.exports = __webpack_public_path__ + "img/Pricing.83048e8b.svg";